import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import HeaderButton from '../../../../components/MenuManager/Header/HeaderButton';
import { MenuItemType } from '../../../../typings/menu';
import DriveItemUtils from '../../../../utils/driveItem';

interface HeaderButtonOwnProps {
	icon?: string;
	label?: string;
	type?: MenuItemType;
	target?: string;
}

enum LocationPathName {
	Folder = '/list/folder',
	Selection = '/list/selection',
}

const mapStateToProps = (state: StoreState, ownProps: HeaderButtonOwnProps) => {
	const {
		appInfos,
		galleryInfos: { config },
		driveList,
		routing,
		routerParamsHistory,
	} = state;
	const { driveItems, resolutions } = driveList;
	const isMultiApp = Utils.isMultiApp(appInfos);

	const { icon, type } = ownProps;
	const iconId = icon && Utils.getMediaId(icon);
	const iconSrc = iconId && iconId > -1 && driveItems[iconId]
		? Utils.getCustomIconUrl(config, driveItems[iconId], resolutions)
		: '';

	const isItemActive = () => {
		if (type === MenuItemType.Selection) {
			return routing.locationBeforeTransitions.pathname === LocationPathName.Selection;
		} else if (type === MenuItemType.Documents) {
			const currentFolderId = Utils.getCurrentFolderId(config.applicationGallery, routerParamsHistory);
			const privateDirId = Utils.getPrivateDirId(driveList, config);
			return routing.locationBeforeTransitions.pathname.includes(LocationPathName.Folder) && DriveItemUtils.isPrivateDirDescendant(currentFolderId, privateDirId, driveItems);
		}

		return false;
	};

	return {
		isMultiApp,
		iconSrc,
		isActive: isItemActive(),
	};
};

export default connect(mapStateToProps)(HeaderButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/HeaderButton/index.tsx